var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84934 12.4029C5.72807 12.4029 5.62592 12.3611 5.54287 12.2774C5.45968 12.1939 5.41809 12.0899 5.41809 11.9654V7.03425L0.415054 0.841088C0.333625 0.729919 0.32194 0.613333 0.379998 0.491332C0.438057 0.369181 0.532861 0.308105 0.664412 0.308105H11.4064C11.538 0.308105 11.6328 0.369181 11.6908 0.491332C11.7489 0.613333 11.7372 0.729919 11.6558 0.841088L6.65275 7.03425V11.9654C6.65275 12.0899 6.61203 12.1939 6.5306 12.2774C6.44918 12.3611 6.34783 12.4029 6.22657 12.4029H5.84934ZM6.03542 5.94933L9.60712 1.48148H2.44167L6.03542 5.94933Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.711c218895fc1497c8610ed40c7b127d.svg";
export { ForwardRef as ReactComponent };